import * as actions from "../../utils/Actions";

    const initialState = {
      showPageLoader: false,
      formStructureSave: null,
      formStructureData:null,
      saveUserResponse:null,
      formBehaviourAndSuccessPgById:null,
      deleteImageFileResponse:null,
      uploadImageFileResponse:null,
      applicantResponseData:null,
      statesAll:[],
      cityAll:[],
      noData:false,
      sendOtpResponse: null,
      verifyOtpResponse: null,
      captchaValue:null,
      saveUserResponseError:null
    };
  
    export default function UserReducer(state = initialState, action) {
      if (typeof state === "undefined") {
        return state;
      }
    
      switch (action.type) {

        case actions.RESET_UPLOAD_DELETE_IMAGE_DATA:
          return {
            ...state,
            deleteImageFileResponse:null,
            uploadImageFileResponse:null,
          }

        // form structure save ::
        case actions.pending(actions.SAVE_FORM_STRUCTURE):
          return {
            ...state,
            showPageLoader: true,
            formStructureSave:null
          };
        case actions.fulfilled(actions.SAVE_FORM_STRUCTURE):
          return {
            ...state,
            showPageLoader: false,
            formStructureSave: action.payload.data,
          };
        case actions.rejected(actions.SAVE_FORM_STRUCTURE):
          return {
            ...state,
            showPageLoader: false,
          };
    
        // Get form structrure by Url
        case actions.pending(actions.GET_FORM_STRUCTURE_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: true,
            formStructureData:null
          };
        case actions.fulfilled(actions.GET_FORM_STRUCTURE_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: false,
            formStructureData: action.payload.data,
            noData:false
          };
        case actions.rejected(actions.GET_FORM_STRUCTURE_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: false,
            noData:true
          };

        // form structure get by id..
        case actions.pending(actions.GET_FORM_STRUCTURE_BY_ID):
          return {
            ...state,
            showPageLoader: true,
            formStructureData:null
          };
        case actions.fulfilled(actions.GET_FORM_STRUCTURE_BY_ID):
          return {
            ...state,
            showPageLoader: false,
            formStructureData: action.payload.data,
          };
        case actions.rejected(actions.GET_FORM_STRUCTURE_BY_ID):
          return {
            ...state,
            showPageLoader: false,
          };


            // save user response.
        case actions.pending(actions.SAVE_USER_RESPONSE):
          return {
            ...state,
            showPageLoader: true,
            saveUserResponse:null,
            saveUserResponseError: null
          };
        case actions.fulfilled(actions.SAVE_USER_RESPONSE):
          return {
            ...state,
            showPageLoader: false,
            saveUserResponse: action.payload.data,
            saveUserResponseError: null
          };
        case actions.rejected(actions.SAVE_USER_RESPONSE):
          return {
            ...state,
            showPageLoader: false,
            saveUserResponseError: action.payload.data
          };
          
            // GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER
        case actions.pending(actions.GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: true,
            formBehaviourAndSuccessPgById:null
          };
        case actions.fulfilled(actions.GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: false,
            formBehaviourAndSuccessPgById: action.payload,
          };
        case actions.rejected(actions.GET_FORM_BEHAVIOR_BY_URL_IDENTIFIER):
          return {
            ...state,
            showPageLoader: false,
          };

        case actions.pending(actions.UPLOAD_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: true,
            uploadImageFileResponse:null
          };
        case actions.fulfilled(actions.UPLOAD_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: false,
            uploadImageFileResponse: action.payload,
          };
        case actions.rejected(actions.UPLOAD_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: false,
          };

        case actions.pending(actions.DELETE_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: true,
            deleteImageFileResponse:null
          };
        case actions.fulfilled(actions.DELETE_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: false,
            deleteImageFileResponse: action.payload,
          };
        case actions.rejected(actions.DELETE_IMAGE_FILE):
          return {
            ...state,
            showPageLoader: false,
          }
          
          
        case actions.pending(actions.GET_APPLICANT_RESPONSE):
          return {
            ...state,
            showPageLoader: true,
            applicantResponseData:null
          };
        case actions.fulfilled(actions.GET_APPLICANT_RESPONSE):
          return {
            ...state,
            showPageLoader: false,
            applicantResponseData: action.payload.data,
          };
        case actions.rejected(actions.GET_APPLICANT_RESPONSE):
          return {
            ...state,
            showPageLoader: false,
          }
              
        case actions.pending(actions.GET_FORM_STATES):
          return {
            ...state,
            showPageLoader: true,
            statesAll:[]
          };
        case actions.fulfilled(actions.GET_FORM_STATES):
          return {
            ...state,
            showPageLoader: false,
            statesAll: action.payload.data,
          };
        case actions.rejected(actions.GET_FORM_STATES):
          return {
            ...state,
            showPageLoader: false,
          }
        
        case actions.pending(actions.GET_FORM_CITY_BY_STATE):
          return {
            ...state,
            showPageLoader: true,
            cityAll:[]
          };
        case actions.fulfilled(actions.GET_FORM_CITY_BY_STATE):
          return {
            ...state,
            showPageLoader: false,
            cityAll: action.payload.data,
          };
        case actions.rejected(actions.GET_FORM_CITY_BY_STATE):
          return {
            ...state,
            showPageLoader: false,
          }

        // OTP related reducers
        case actions.pending(actions.SEND_OTP):
          return {
            ...state,
            showPageLoader: true,
            sendOtpResponse: null
          };
        case actions.fulfilled(actions.SEND_OTP):
          return {
            ...state,
            showPageLoader: false,
            sendOtpResponse: action.payload.data
          };
        case actions.rejected(actions.SEND_OTP):
          return {
            ...state,
            showPageLoader: false
          };

        case actions.pending(actions.VERIFY_OTP):
          return {
            ...state,
            showPageLoader: true,
            verifyOtpResponse: null
          };
        case actions.fulfilled(actions.VERIFY_OTP):
          return {
            ...state,
            showPageLoader: false,
            verifyOtpResponse: action.payload.data
          };
        case actions.rejected(actions.VERIFY_OTP):
          return {
            ...state,
            showPageLoader: false,
            verifyOtpResponse: action.payload.data
          };

        case actions.pending(actions.GET_CAPTCHA_VALUE):
          return {
            ...state
          }

        case actions.fulfilled(actions.GET_CAPTCHA_VALUE):
          return {
            ...state,
            captchaValue: action.payload.data
          }

        case actions.rejected(actions.GET_CAPTCHA_VALUE):
          return {
            ...state
          }
          
        case actions.pending(actions.GET_PUBLIC_KEY):
          return {
            ...state,
            showPageLoader: true,
            downloadBulkResponse:null
          };
        case actions.fulfilled(actions.GET_PUBLIC_KEY):
          return {
            ...state,
            showPageLoader: false,
            publicEncryptionKey: action.payload.data,
          };
        case actions.rejected(actions.GET_PUBLIC_KEY):
          return {
            ...state,
            showPageLoader: false,
          };
          
        default:
          return { ...state };
      }
    }